<template>
  <div ref="domRef" :class="['base-card-info', marginBottom ? 'mb-0' : '']">
    <div class="info-card-title">
      开户许可证信息
    </div>
    <change-record-container>
      <template #before>
        <div class="left-list gap-y-[14px]">
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLicense?.phoneNo, baseInfo?.post?.companyLicense?.phoneNo)" class="item">
            <div class="label">
              银行预留手机号
            </div>
            <div class="value">
              {{ isNull(baseInfo?.pre?.companyLicense?.phoneNo) ? '--' : baseInfo?.pre?.companyLicense?.phoneNo }}
            </div>
          </div>
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLicense?.bankName, baseInfo?.post?.companyLicense?.bankName)" class="item">
            <div class="label">
              开户银行
            </div>
            <div class="value">
              {{ isNull(baseInfo?.pre?.companyLicense?.bankName) ? '--' : baseInfo?.pre?.companyLicense?.bankName }}
            </div>
          </div>
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLicense?.bankAccount, baseInfo?.post?.companyLicense?.bankAccount)" class="item">
            <div class="label">
              银行账号
            </div>
            <div class="value">
              {{ isNull(baseInfo?.pre?.companyLicense?.bankAccount) ? '--' : baseInfo?.pre?.companyLicense?.bankAccount }}
            </div>
          </div>
          <div 
            v-if="!deepEqualField(baseInfo?.pre?.companyLicense?.licenseUrl, baseInfo?.post?.companyLicense?.licenseUrl)" 
            class="item"
          >
            <div class="label">
              银行开户许可证
            </div>
            <div class="value">
              <div v-if="baseInfo?.pre?.companyLicense?.licenseUrl" class="business-license-box">
                <img
                  :src="baseInfo?.pre?.companyLicense?.licenseUrl"
                >
              </div>
              <div v-else class="business-license-box" />
            </div>
          </div>
        </div>
      </template>
      <template #after>
        <div class="left-list gap-y-[14px]">
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLicense?.phoneNo, baseInfo?.post?.companyLicense?.phoneNo)" class="item">
            <div class="label">
              银行预留手机号
            </div>
            <div class="value">
              {{ isNull(baseInfo?.post?.companyLicense?.phoneNo) ? '--' : baseInfo?.post?.companyLicense?.phoneNo }}
            </div>
          </div>
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLicense?.bankName, baseInfo?.post?.companyLicense?.bankName)" class="item">
            <div class="label">
              开户银行
            </div>
            <div class="value">
              {{ isNull(baseInfo?.post?.companyLicense?.bankName) ? '--' : baseInfo?.post?.companyLicense?.bankName }}
            </div>
          </div>
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLicense?.bankAccount, baseInfo?.post?.companyLicense?.bankAccount)" class="item">
            <div class="label">
              银行账号
            </div>
            <div class="value">
              {{ isNull(baseInfo?.post?.companyLicense?.bankAccount) ? '--' : baseInfo?.post?.companyLicense?.bankAccount }}
            </div>
          </div>
          <div 
            v-if="!deepEqualField(baseInfo?.pre?.companyLicense?.licenseUrl, baseInfo?.post?.companyLicense?.licenseUrl)" 
            class="item"
          >
            <div class="label">
              银行开户许可证
            </div>
            <div class="value">
              <div v-if="baseInfo?.post?.companyLicense?.licenseUrl" class="business-license-box">
                <img
                  :src="baseInfo?.post?.companyLicense?.licenseUrl"
                >
              </div>
              <div v-else class="business-license-box" />
            </div>
          </div>
        </div>
      </template>
    </change-record-container>
  </div>
</template>

<script setup lang="ts">
import { deepEqualField, isNull } from '@core/tools';
import ChangeRecordContainer from './change-record-container.vue';
import { useElementImgPreview } from '@vue3/components';
import { ICompanyChangeRecord } from '@core/main/types';
import { inject, Ref, ref } from 'vue';

defineOptions({ name: 'LicenceInfo' }); // 账户中心 - 开户许可证信息

const domRef = ref<HTMLDivElement>();

useElementImgPreview(domRef);

defineProps({
  marginBottom: {
    type: Boolean,
    default: false,
  },
});

const baseInfo = inject<Ref<ICompanyChangeRecord>>('baseInfo');
</script>
